"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.agileStandupAppealCard = void 0;
const adaptivecards_1 = require("adaptivecards");
const commands_1 = require("../../_shared/commands");
const components_1 = require("../../_shared/components");
const AppealTitle_1 = require("../../_shared/components/AppealTitle");
const CardHelper_1 = require("../../_shared/utils/CardHelper");
const actions_1 = require("../../survey/actions");
const surveyHelpers_1 = require("../../survey/utils/surveyHelpers");
const agileStandupAppealCard = (survey, options) => {
    var _a;
    const card = CardHelper_1.CardHelper.newCard();
    if (options === null || options === void 0 ? void 0 : options.hideManagementControls) {
        card.addItem((0, AppealTitle_1.AppealTitle)(survey));
    }
    else {
        card.addItem((0, AppealTitle_1.AppealTitleWithManagementMenu)(survey));
    }
    if (survey.description) {
        card.addItem(CardHelper_1.CardHelper.create(adaptivecards_1.TextBlock, {
            text: survey.description,
            spacing: adaptivecards_1.Spacing.Medium,
            wrap: true,
        }));
    }
    if (!(options === null || options === void 0 ? void 0 : options.hideDetailsBar)) {
        card.addItem((0, components_1.detailsBar)(survey, {
            hideAnonymity: true,
            showStatus: false,
            showCompletions: false,
            hideOwner: true,
        }));
    }
    if ((options === null || options === void 0 ? void 0 : options.isEdited) || (options === null || options === void 0 ? void 0 : options.reOpened)) {
        card.addItem(CardHelper_1.CardHelper.create(adaptivecards_1.TextBlock, {
            weight: adaptivecards_1.TextWeight.Bolder,
            color: adaptivecards_1.TextColor.Good,
            wrap: true,
            text: options.isEdited
                ? (0, surveyHelpers_1.getSurveyEditText)(options.votesInvalidated)
                : (0, surveyHelpers_1.getSurveyReOpenedText)(),
        }));
    }
    if (survey.state === "open") {
        survey.questions.forEach((question, i) => {
            const questionElement = (0, components_1.questionTakingContainer)(question, i + 1, {
                hideQuestionIndex: true,
                hideSettingsBar: true,
            });
            questionElement.spacing = adaptivecards_1.Spacing.Medium;
            questionElement.style = adaptivecards_1.ContainerStyle.Default;
            card.addItem(questionElement);
        });
        const subAction = CardHelper_1.CardHelper.create(adaptivecards_1.SubmitAction, {
            // NOTE: if this text is changed, make sure to change the text in Polly preview as well.
            title: "Submit response",
            data: (0, commands_1.takingSubmitCommand)(survey.id, survey.questions[0].id, survey.questions.map(q => q.id)).toInvokeCommand(),
        });
        card.addAction(subAction);
    }
    if (survey.state === "closed") {
        const container = CardHelper_1.CardHelper.create(adaptivecards_1.Container, {
            style: adaptivecards_1.ContainerStyle.Emphasis,
        });
        (_a = options === null || options === void 0 ? void 0 : options.resultText) === null || _a === void 0 ? void 0 : _a.forEach(result => container.addItem(CardHelper_1.CardHelper.create(adaptivecards_1.TextBlock, {
            horizontalAlignment: adaptivecards_1.HorizontalAlignment.Left,
            size: adaptivecards_1.TextSize.Medium,
            text: result,
            wrap: true,
        })));
        card.addItem(container);
    }
    const viewResults = (0, actions_1.ViewSurveyResultsAction)(survey.id, "View all responses");
    card.addAction(viewResults);
    return card;
};
exports.agileStandupAppealCard = agileStandupAppealCard;
//# sourceMappingURL=AgileStandupAppealCard.js.map